import React, { useMemo } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Divider,
} from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import moment from "moment";
import { lightTable } from "../../../styles/muiProps";

const InfoCard = ({ title, data }) => {
  return (
    <Card
      elevation={2}
      sx={{
        height: "100%",
        borderRadius: 3,
      }}
    >
      <CardContent>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          {title}
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <Grid container spacing={2}>
          {Object.entries(data).map(([key, value]) => (
            <Grid item xs={12} sm={6} key={key}>
              <Box
                sx={{
                  p: 2,
                  borderRadius: 2,
                  backgroundColor: "grey.50",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="body2" color="text.secondary">
                  {key}
                </Typography>

                <Typography variant="subtitle2" fontWeight={600}>
                  {value}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

const DashboardPage = ({ data }) => {
  // Table columns

  const columns = useMemo(
    () => [
      {
        header: "Part/Tag/Mark #",
        accessorKey: "item",
        Cell: ({ row }) => {
          return (
            row.original.mrqMaterial?.materials?.[0]?.bulkMaterial?.item || ""
          );
        },
      },
      {
        header: "Description",
        accessorKey: "desc",
        Cell: ({ row }) => {
          return (
            row.original.mrqMaterial?.description ||
            row.original.description ||
            "-"
          );
        },
      },
      {
        header: "Procured Qty",
        accessorKey: "qty",
        Cell: ({ row }) => {
          return (
            row.original.mrqMaterial?.procuredQty ||
            row.original.quantity ||
            "-"
          );
        },
      },
      {
        header: "Unit",
        accessorKey: "unit",
        Cell: ({ row }) => {
          return row.original.mrqMaterial?.unit || "-";
        },
      },
      {
        header: "Cost/Unit",
        accessorKey: "cost",
      },
      {
        header: "Total Cost",
        accessorKey: "totalCost",
        Cell: ({ row }) => {
          const cost = row.original.cost || 0;
          const qty =
            row.original.mrqMaterial?.procuredQty || row.original.quantity || 0;
          return cost && qty ? `$ ${cost * qty}` : "-";
        },
      },
      {
        header: "Delivery Date",
        accessorKey: "date",
        Cell: ({ row }) => {
          return `in ${row.original.time} days`;
        },
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    data: data?.poMaterials || [],
    columns,
    ...lightTable,
  });

  console.log({ data });

  const mrqData = {
    "MRQ Number": data?.mrq?.mrqNumber,
    "MRQ Revision": data?.mrq?.rev,
    "MRQ Title": data?.mrq?.title,
    "Issued At": moment(data?.mrq?.createdAt).format("YYYY-MM-DD"),
  };

  const poData = {
    "Company Name": "ChinookDT",
    "PO Number": data?.poNumber,
    "PO Revision": data?.revision,
    "PO Title": data?.title,
    "Issued At": moment(data?.createdAt).format("YYYY-MM-DD"),
  };

  return (
    <Box sx={{ p: 4 }}>
      {/* Cards Section */}
      <Grid container spacing={3} mb={4}>
        <Grid item xs={12} md={6}>
          <InfoCard title="Assigned PO Details" data={poData} />
        </Grid>

        <Grid item xs={12} md={6}>
          <InfoCard title="Related MRQ Details" data={mrqData} />
        </Grid>
      </Grid>

      {/* Table Section */}
      <Card elevation={2} sx={{ borderRadius: 3 }}>
        <CardContent>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            Attached Materials
          </Typography>
          <Divider sx={{ mb: 3 }} />
          <MaterialReactTable table={table} />{" "}
        </CardContent>
      </Card>

      <Card elevation={2} sx={{ borderRadius: 3, mt: 4 }}>
        <CardContent>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            Payment Terms
          </Typography>
          <Divider sx={{ mb: 3 }} />
        </CardContent>
      </Card>
    </Box>
  );
};

export default DashboardPage;
